export default "__VITE_ASSET__CCtZTWSe__"